import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import queryString from 'query-string';

import { AuthCallback, ProtectedRoute, withAuth } from 'school-space-client/components';

import Dashboard from './dashboard/Dashboard';
import authHandler from './auth/AuthHandler';

const App = ({ auth, login, logout }) => (
    <Switch>
        <Route
            exact
            path="/login"
            render={({ location }) => {
                const { email } = queryString.parse(location.search) || {};
                return login(email);
            }}
        />
        <Route exact path="/logout" render={() => logout()} />
        <Route exact path="/callback" render={props => <AuthCallback {...props} auth={auth} />} />
        <ProtectedRoute path="/" component={Dashboard} auth={auth} />
    </Switch>
);

App.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired
};

export default withAuth(App, authHandler);
